import React from 'react';

import _ from 'lodash';

import InputDateField from './InputDateField';
import InputCurrencyField from './InputCurrencyField';

import './FeeTableRow.scss';


class FeeTableRow extends React.Component {
  _onInputChange(inputId) {
    return value => {
      const { onValueChange } = this.props;

      const fee = _.cloneDeep(this.props.fee);
      fee.fields[inputId].value = value;

      // if ([ 'price', 'tax_1', 'tax_2', 'tax_3', 'tax_4' ].includes(inputId)) {
      //   fee.updateGrossPrice();
      // }

      onValueChange(fee);
    };
  }

  render() {
    const {
      fee,
      inputId,
      ident,
      editMode
    } = this.props;

    const disabledMode = {
      start_date: false,
      price: false,
      tax_1: false,
      tax_2: false,
      tax_3: false,
      tax_4: false,
      ...this.props.disabledMode || {}
    };

    return (
      <div className="parkchirp--fee-table-row">
        <div className={`parkchirp--fee-table--cell` +
          ` parkchirp--fee-table--start-date-column`}>
          <InputDateField inputId={`${inputId}--${ident}--start-date`}
            key={`${inputId}--${ident}--start-date--${fee.fields.start_date.value}`}
            value={fee.fields.start_date.value}
            onChange={this._onInputChange('start_date')}
            editMode={editMode}
            disabledMode={disabledMode.start_date}
          />
        </div>
        <div className={`parkchirp--fee-table--cell` +
          ` parkchirp--fee-table--net-amount-column`}>
          <InputCurrencyField inputId={`${inputId}--${ident}--price`}
            key={`${inputId}--${ident}--price--${fee.fields.price.value}`}
            value={fee.fields.price.value}
            onChange={this._onInputChange('price')}
            editMode={editMode}
            disabledMode={disabledMode.price}
          />
        </div>
        <div className={`parkchirp--fee-table--cell` +
          ` parkchirp--fee-table--tax-1-amount-column`}>
          <InputCurrencyField inputId={`${inputId}--${ident}--tax-1`}
            key={`${inputId}--${ident}--tax-1--${fee.fields.tax_1.value}`}
            value={fee.fields.tax_1.value}
            onChange={this._onInputChange('tax_1')}
            editMode={editMode}
            disabledMode={disabledMode.tax_1}
          />
        </div>
        <div className={`parkchirp--fee-table--cell` +
          ` parkchirp--fee-table--tax-2-amount-column`}>
          <InputCurrencyField inputId={`${inputId}--${ident}--tax-2`}
            key={`${inputId}--${ident}--tax-2--${fee.fields.tax_2.value}`}
            value={fee.fields.tax_2.value}
            onChange={this._onInputChange('tax_2')}
            editMode={editMode}
            disabledMode={disabledMode.tax_2}
          />
        </div>
        <div className={`parkchirp--fee-table--cell` +
          ` parkchirp--fee-table--tax-3-amount-column`}>
          <InputCurrencyField inputId={`${inputId}--${ident}--tax-3`}
            key={`${inputId}--${ident}--tax-3--${fee.fields.tax_3.value}`}
            value={fee.fields.tax_3.value}
            onChange={this._onInputChange('tax_3')}
            editMode={editMode}
            disabledMode={disabledMode.tax_3}
          />
        </div>
        <div className={`parkchirp--fee-table--cell` +
          ` parkchirp--fee-table--tax-4-amount-column`}>
          <InputCurrencyField inputId={`${inputId}--${ident}--tax-4`}
            key={`${inputId}--${ident}--tax-4--${fee.fields.tax_4.value}`}
            value={fee.fields.tax_4.value}
            onChange={this._onInputChange('tax_4')}
            editMode={editMode}
            disabledMode={disabledMode.tax_4}
          />
        </div>
        <div className={`parkchirp--fee-table--cell` +
          ` parkchirp--fee-table--gross-amount-column`}>
          <InputCurrencyField inputId={`${inputId}--${ident}--gross-price`}
            key={`${inputId}--${ident}--gross-price--${fee.fields.gross_price.value}`}
            value={fee.fields.gross_price.value}
            editMode={false}
          />
        </div>
      </div>
    );
  }
}
export default FeeTableRow;
